module.exports = __webpack_public_path__ + "static/media/mask-pink@3x.0530593f.png";